export interface Props {
  handleSetResponse: (inputAnswer: string) => void;
}
export default function QuestionStatement({
  handleSetResponse = () => {},
}: Props): React.ReactElement {
  return <></>;
}
